var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "firmware-develop-details" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c("div", { staticClass: "top" }, [
          _c("span", { staticClass: "back", on: { click: _vm.goBack } }, [
            _c("i", {
              staticClass: "iconfont icon-fanhui",
              staticStyle: { "font-size": "24px" },
            }),
          ]),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.productName)),
          ]),
        ]),
        _c("div", { staticClass: "version" }, [
          _vm._v("版本号：" + _vm._s(_vm.version)),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "tab" },
      [
        _c(
          "el-menu",
          {
            staticClass: "el-menu-demo",
            attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
            on: { select: _vm.handleSelect },
          },
          [
            _c("el-menu-item", { attrs: { index: "1" } }, [
              _c("span", [_vm._v("测试任务")]),
            ]),
            _c("el-menu-item", { attrs: { index: "2" } }, [
              _c("span", [_vm._v("升级任务")]),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeIndex == "1",
                  expression: "activeIndex == '1'",
                },
              ],
            },
            [_c("testTask")],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeIndex == "2",
                  expression: "activeIndex == '2'",
                },
              ],
            },
            [_c("upgradeTask")],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }